import LocalizedStrings from 'react-localization';
export const lang = new LocalizedStrings({
  en: {
    uninstall: 'Uninstall Search Administrator',
    important:
      'IMPORTANT: Uninstalling will cause your searches to be tracked and your search history to be stored by Google, Microsoft and other institutions.',
    remove_steps: 'Remove or Uninstall Search Administrator from Google Chrome',
    remove_step1: 'Click the Chrome menu  on the browser toolbar.',
    remove_step2: "Click 'More tools' and Select 'Extensions'",
    remove_step3: "Find Search Administrator and click 'Remove' button.",
    turn_off:
      '* You can also temporarily turn off Search Administrator by disabling it on the Extensions page.',
    remove_ff: 'Remove or Uninstall Search Administrator from Mozilla Firefox',
    remove_ff_1: 'Click the Firefox menu  on the browser toolbar.',
    remove_ff_2: "Click 'Add-ons'  and 'Extensions'",
    remove_ff_3: "Click 'Disable' or 'Remove'",
    title: 'Uninstall - Search Administrator',
    description:
      'The official instruction to properly Uninstall Search Administrator on your Google Chrome.',
  },
  pt: {
    uninstall: 'Desinstalar Search Administrator',
    important:
      'IMPORTANTE: A desinstalação fará com que as suas pesquisas sejam monitorizadas e com que o seu histórico de pesquisas seja armazenado pelo Google, Microsoft e outras instituições.',
    remove_steps: 'Remover ou Desinstalar o Search Administrator do Google Chrome',
    remove_step1: 'Clique no menu do Chrome  na barra de ferramentas do navegador.',
    remove_step2: 'Clique em "Mais ferramentas" e Selecione "Extensões".',
    remove_step3: 'Localize o Search Administrator e clique no botão ‘Remover’.',
    turn_off:
      '* Pode também desligar o Search Administrator temporariamente, desativando-o na página das Extensões.',
    remove_ff: 'Remover ou Desinstalar o Search Administrator do Mozilla Firefox',
    remove_ff_1: 'Clique no menu do Firefox  na barra de ferramentas do navegador.',
    remove_ff_2: 'Clique em Extras  e "Extensões".',
    remove_ff_3: 'Clique em "Desativar" ou "Remover"',
    title: 'Desinstalar - Search Administrator',
    description:
      'A instrução oficial para Desinstalar corretamente o Search Administrator no seu Google Chrome.',
  },
});



// WEBPACK FOOTER //
// ./src/lang_uninstall.js